module.exports = __webpack_public_path__ + "img/new_62.94c4e5d0.jpg";